import React, { useState } from 'react';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import styles from './navbar.module.scss';
import logo from '../../asset/images/logo-full.png';
import IconsColor from '../../util/iconsColor';
import { NavItem } from '../../models';
import { useUserDetail } from 'context/userDetailContext';
import { isAdminUser } from 'util/isAdminUser';
import { MenuItem, Popover } from '@mui/material';
import { agent } from 'apiClient/api';
import { useSnackbar } from 'context/snackbarContext';
import { MdLogout } from 'react-icons/md';

const navItems: NavItem[] = [
  {
    id: 'quotation',
    label: 'Quotation',
    path: '/quotation',
    icon: <IconsColor iconName="dashboard" width="18" height="18" fillColor="none" />,
    disabled: false
  },
  {
    id: 'hotels',
    label: 'Hotels',
    path: '/hotels',
    icon: <IconsColor iconName="hotels" width="18" height="18" fillColor="none" />,
    disabled: false
  },
  {
    id: 'excursions',
    label: 'Excursions',
    path: '/excursions',
    icon: <IconsColor iconName="excursions" width="18" height="18" fillColor="none" />,
    disabled: false

  },
  {
    id: 'places',
    label: 'Places',
    path: '/places',
    icon: <IconsColor iconName="places" width="18" height="18" fillColor="none" />,
    disabled: false
  },
  {
    id: 'Trips',
    label: 'Trips',
    path: '/transportation',
    icon: <IconsColor iconName="transportation" width="18" height="18" fillColor="none" />,
    disabled: false
  },
  {
    id: 'guides',
    label: 'Guides',
    path: '/guides',
    icon: <IconsColor iconName="guides" width="18" height="18" fillColor="none" />,
    disabled: false
  },
  {
    id: 'agency',
    label: 'Agency',
    path: '/agency',
    icon: <IconsColor iconName="agents" width="18" height="18" fillColor="none" />,
    disabled: false
  },
];

const Navbar: React.FC = () => {

  const { userDetail, setUserDetail } = useUserDetail();
  const { showError } = useSnackbar()
  const location = useLocation()
  const visibleNavItems: NavItem[] = isAdminUser(userDetail)
    ? [
        ...navItems,
        {
          id: 'configuration',
          label: 'Configuration',
          path: '/configuration/users',
          icon: <IconsColor iconName="gearIcon" width="18" height="18" fillColor="none" />,
          disabled: false,
        },
      ]
    : navItems

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const navigate = useNavigate();

  const userProfileClick = (e: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(e.currentTarget);
  }

  const closeUserProfileOptions = () => {
    setAnchorEl(null);
  }

  const logout = async () => {
    try {
      const response = await agent.LogoutAPI.post();
      if(response.status) {
        setUserDetail(null);
        navigate("/login", {
          replace: true
        })
      }
      else {
        showError("Failed to logout!");
      }
    }
    catch(err) {
      console.error("Got error while logout", err);
      showError("Something went wrong, Please try again later.");
    }
  }

  const flagMenuOpen = Boolean(anchorEl);

  return (
    <nav className={styles.navbar}>
      <div className={styles.navbarContainer}>
        {/* Logo Section */}
        <div className={styles.navbarLogo}>
          <NavLink to="#">
            <img src={logo} alt="Travel Advocates" className={styles.logoImage} />
          </NavLink>
        </div>

        {/* Navigation Menu */}
        <div className={styles.navbarMenu}>
          {visibleNavItems.map((item: NavItem) => (
            <NavLink
              key={item.id}
              to={item.path}
              className={({ isActive }) => {
                const active = item.id === 'configuration'
                  ? location.pathname.startsWith('/configuration')
                  : isActive
                return `${styles.navItem} ${active ? styles.active : ''} ${item.disabled ? styles.disabled : ''}`
              }}
              onClick={(e) => {
                if (item.disabled) e.preventDefault();
              }}
            >
              <span className={styles.navIcon}>{item.icon}</span>
              <span className={styles.navLabel}>{item.label}</span>
            </NavLink>
          ))}
        </div>

        {/* User Profile Section */}
        <div className={styles.navbarUser}>
          <div className={styles.userInfo}>
            <span className={styles.userName}>{userDetail?.user_first_name} {userDetail?.user_last_name}</span>
            <span className={styles.userType}>{userDetail?.user_role_name}</span>
          </div>
          <div className={styles.userAvatar} onClick={userProfileClick}>
            <span className={styles.avatarText}>{userDetail?.user_first_name?.charAt(0)}</span>
          </div>
        </div>
        <Popover
          open={flagMenuOpen}
          anchorEl={anchorEl}
          className={styles.userProfileOptions}
          onClose={closeUserProfileOptions}
          slotProps={{ paper: { className: styles.userProfilePaper } }}
        >
          <MenuItem onClick={logout} className={styles.logoutMenuItem} disableRipple>
            <span className={styles.logoutIcon}>
              <MdLogout size={18} />
            </span>
            <span className={styles.logoutLabel}>Logout</span>
          </MenuItem>
        </Popover>
      </div>
    </nav>
  );
};

export default Navbar;

